const routes = [
    {
        path: "/proficiency/exams/",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'proficiencyexam_index'
        }
    }
];

export default routes;
